import { carePhaseDefList, isNullOrUndefined } from '@shared';

export function calcClientPhaseStartYears(
  client: Client,
): Record<CarePhase, number | null> {
  // combined predicted start years and actual start years into one record
  const {
    clientPhasePredictedStartYears,
    intakeSurvey: { clientPhaseStartAges, clientBirthYear },
  } = client;

  const phaseStartYears: Record<CarePhase, number | null> = {} as Record<
    CarePhase,
    number | null
  >;

  for (const carePhaseDef of carePhaseDefList) {
    const carePhase = carePhaseDef.value;
    const predictedStartYear = clientPhasePredictedStartYears[carePhase];
    if (predictedStartYear) {
      phaseStartYears[carePhase] = predictedStartYear;
    } else if (!isNullOrUndefined(clientPhaseStartAges[carePhase])) {
      phaseStartYears[carePhase] =
        clientBirthYear + clientPhaseStartAges[carePhase]!;
    } else {
      phaseStartYears[carePhase] = null;
    }
  }

  return phaseStartYears;
}

export function calcProjectedCareYearRange(
  client: Client,
): { startYear: number; endYear: number } | null {
  const isYear = (year: number | null): year is number => typeof year === 'number' && year > 0;
  const startYears = Object.values(calcClientPhaseStartYears(client)).filter(isYear);
  const endYears = Object.values(client.clientPhasePredictedEndYears ?? {}).filter(isYear);
  if (startYears.length === 0 || endYears.length === 0) {
    return null;
  }

  return {
    startYear: Math.round(Math.min(...startYears)),
    endYear: Math.round(Math.max(...endYears)),
  };
}
